import { TableRow, TableCell, Checkbox } from '@occc-app/design-system';
import { Location } from '@occc/graphql';

type LocationsTableItemProps = {
  location: Location;
  isItemSelected: boolean;
  handleItemSelect: (id: string) => void;
};

const LocationsTableItem = ({
  location,
  isItemSelected,
  handleItemSelect,
}: LocationsTableItemProps) => {
  const locationCity = location?.address?.city || '';
  const locationState = location?.address?.state || '';
  const locationStreet = location?.address?.street1 || '';
  const locationZip = location?.address?.zipCode || '';
  const siteId = location?.siteSystemConfiguration?.[0]?.identifier || '';
  const siteName = location.name || '';
  const sitePhoneNumber = location?.phoneNumbers?.[0]?.phoneNumber || '';

  return (
    <TableRow key={location.uuid} selected={isItemSelected}>
      <TableCell padding='checkbox'>
        <Checkbox
          checked={isItemSelected}
          onClick={(event) => {
            event.stopPropagation();
            handleItemSelect(location.uuid);
          }}
        />
      </TableCell>
      <TableCell>{siteId}</TableCell>
      <TableCell>{siteName}</TableCell>
      <TableCell>
        {locationStreet}
        <br />
        {`${locationCity}, ${locationState} ${locationZip}`}
      </TableCell>
      <TableCell>{sitePhoneNumber}</TableCell>
    </TableRow>
  );
};

export default LocationsTableItem;
